export default __webpack_public_path__ + "static/image-8-mob-9d0de604fe2d2ca45a3f2f1dd061b879.jpg";